import React from "react";
import PropTypes from "prop-types";
import { FaMapMarkerAlt } from "react-icons/fa";

import "./PackageListing.scss";

export default class PackageListing extends React.Component {
  render() {
    return (
      <div
        className="packageListing"
        style={{ backgroundColor: this.props.color }}
        onClick={this.props.onClick}
        id={this.props.id}
      >
        <h3>{this.props.name || <span>&nbsp;</span>}</h3>
        <p className="packageDate">
          {(this.props.date && `Delivery by: ${this.props.date}`) || (
            <span>&nbsp;</span>
          )}
        </p>
        <p className="packageLocation">
          <FaMapMarkerAlt />
          {this.props.location || <span>&nbsp;</span>}
        </p>
      </div>
    );
  }
}

PackageListing.propTypes = {
  name: PropTypes.string,
  date: PropTypes.string,
  location: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string.isRequired
};
